/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IInternalRegulationObligationRisksQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.IInternalRegulationObligationRisksInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type IInternalRegulationObligationRisksQuery = {
  __typename?: 'Query';
  internalRegulationObligationRisks: {
    __typename: 'InternalRegulationObligationRiskConnection';
    edges: Array<{
      __typename: 'InternalRegulationObligationRiskEdge';
      cursor: string;
      node: {
        __typename: 'InternalRegulationObligationRisk';
        id: string;
        name?: string | null;
        approvalStatus?: Types.IInternalRegulationObligationApprovalStatus | null;
      };
    }>;
    pageInfo: { __typename: 'CursorPageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export const InternalRegulationObligationRisksDocument = gql`
  query InternalRegulationObligationRisks($input: InternalRegulationObligationRisksInput, $first: Int, $after: String) {
    internalRegulationObligationRisks(input: $input, first: $first, after: $after) {
      __typename
      edges {
        __typename
        node {
          __typename
          id
          name
          approvalStatus
        }
        cursor
      }
      pageInfo {
        __typename
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useInternalRegulationObligationRisksQuery__
 *
 * To run a query within a React component, call `useInternalRegulationObligationRisksQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalRegulationObligationRisksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalRegulationObligationRisksQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInternalRegulationObligationRisksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IInternalRegulationObligationRisksQuery,
    IInternalRegulationObligationRisksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IInternalRegulationObligationRisksQuery, IInternalRegulationObligationRisksQueryVariables>(
    InternalRegulationObligationRisksDocument,
    options,
  );
}
export function useInternalRegulationObligationRisksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IInternalRegulationObligationRisksQuery,
    IInternalRegulationObligationRisksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IInternalRegulationObligationRisksQuery, IInternalRegulationObligationRisksQueryVariables>(
    InternalRegulationObligationRisksDocument,
    options,
  );
}
// @ts-ignore
export function useInternalRegulationObligationRisksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IInternalRegulationObligationRisksQuery,
    IInternalRegulationObligationRisksQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  IInternalRegulationObligationRisksQuery,
  IInternalRegulationObligationRisksQueryVariables
>;
export function useInternalRegulationObligationRisksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IInternalRegulationObligationRisksQuery,
        IInternalRegulationObligationRisksQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  IInternalRegulationObligationRisksQuery | undefined,
  IInternalRegulationObligationRisksQueryVariables
>;
export function useInternalRegulationObligationRisksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IInternalRegulationObligationRisksQuery,
        IInternalRegulationObligationRisksQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    IInternalRegulationObligationRisksQuery,
    IInternalRegulationObligationRisksQueryVariables
  >(InternalRegulationObligationRisksDocument, options);
}
export type InternalRegulationObligationRisksQueryHookResult = ReturnType<
  typeof useInternalRegulationObligationRisksQuery
>;
export type InternalRegulationObligationRisksLazyQueryHookResult = ReturnType<
  typeof useInternalRegulationObligationRisksLazyQuery
>;
export type InternalRegulationObligationRisksSuspenseQueryHookResult = ReturnType<
  typeof useInternalRegulationObligationRisksSuspenseQuery
>;
export type InternalRegulationObligationRisksQueryResult = Apollo.QueryResult<
  IInternalRegulationObligationRisksQuery,
  IInternalRegulationObligationRisksQueryVariables
>;
